import {
    GET_SUBSCRIPTION_FEATURES_DATA,
    UPDATE_SUBSCRIPTION_FEATURES_DATA
} from "../Actions/subscriptions";


import {
    SITE_API,
    API,
    GET_SUBSCRIPTION_FEATURES_DATA_URL,
    UPDATE_SUBSCRIPTION_FEATURES_DATA_URL

} from "../variable";
import axios from 'axios'

const state = {

};

const actions = {
    [GET_SUBSCRIPTION_FEATURES_DATA]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + GET_SUBSCRIPTION_FEATURES_DATA_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken }
        });
    },
    [UPDATE_SUBSCRIPTION_FEATURES_DATA]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + UPDATE_SUBSCRIPTION_FEATURES_DATA_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken }
        });
    }

};

const mutations = {

};

const getters = {



};

export default {
    state,
    getters,
    actions,
    mutations
};